// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    GIFT_PAGE_LOADING() {
      return {
        isLoading: true,
        giftPage: action.giftPage
      };
    },
    GIFT_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.homepage
      };
    },
    GIFT_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.giftPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
